import { type userType } from '../common-types';

export interface KnowledgeCardTeamSearchRelevanceType {
	knowledgeDiscovery: {
		searchTeam: {
			id?: string | null | undefined;
			message?: string | null | undefined;
		};
	};
}

export interface KnowledgeCardTeamSearchRelevanceVariables {
	teamQuery: string;
	orgId: string;
	siteId: string;
}

export const KNOWLEDGE_CARD_TEAM_SEARCH_RELEVANCE_OPERATION_NAME = 'KnowledgeCardTeamSearchQuery';
export const KnowledgeCardTeamSearchRelevanceQuery: '\nquery KnowledgeCardTeamSearchQuery($teamQuery: String!, $orgId: String!, $siteId: String!) {\n  knowledgeDiscovery {\n   \tsearchTeam (\n        teamName: $teamQuery\n        orgId: $orgId\n        siteId: $siteId\n    ) @optIn(to: "KnowledgeDiscovery Search Team"){\n      ... on KnowledgeDiscoveryTeam {\n        id\n      }\n      ... on QueryError {\n        message\n      }\n    }\n  }\n}\n' = `
query ${KNOWLEDGE_CARD_TEAM_SEARCH_RELEVANCE_OPERATION_NAME}($teamQuery: String!, $orgId: String!, $siteId: String!) {
  knowledgeDiscovery {
   	searchTeam (
        teamName: $teamQuery
        orgId: $orgId
        siteId: $siteId
    ) @optIn(to: "KnowledgeDiscovery Search Team"){
      ... on KnowledgeDiscoveryTeam {
        id
      }
      ... on QueryError {
        message
      }
    }
  }
}
`;

export interface KnowledgeCardTeamSearchMemberNodeType {
	member?: userType | null;
	state?: string | null;
}

export interface KnowledgeCardTeamDataType {
	team: {
		teamV2?: {
			id: string;
			displayName?: string | null;
			smallAvatarImageUrl?: string | null;
			members: {
				nodes: KnowledgeCardTeamSearchMemberNodeType[];
			};
		} | null;
	};
}

export interface KnowledgeCardTeamDataVariables {
	teamId: string;
	siteId: string;
}

export const KNOWLEDGE_CARD_TEAM_DATA_OPERATION_NAME = 'KnowledgeCardTeamDataQuery';
export const KnowledgeCardTeamDataQuery: '\nquery KnowledgeCardTeamDataQuery($teamId: ID!, $siteId: String!) {\n    team {\n      teamV2 (\n        id: $teamId\n        siteId: $siteId\n      ) @optIn(to: "Team-v2") {\n        id\n        displayName\n        smallAvatarImageUrl\n        members {\n          nodes {\n            member {\n              id\n              accountId\n              name\n              picture\n              ... on AtlassianAccountUser {\n                email\n                extendedProfile {\n                  jobTitle\n                  department\n                }\n              }\n            }\n            state\n          }\n        }\n      }\n    }\n  }\n' = `
query ${KNOWLEDGE_CARD_TEAM_DATA_OPERATION_NAME}($teamId: ID!, $siteId: String!) {
    team {
      teamV2 (
        id: $teamId
        siteId: $siteId
      ) @optIn(to: "Team-v2") {
        id
        displayName
        smallAvatarImageUrl
        members {
          nodes {
            member {
              id
              accountId
              name
              picture
              ... on AtlassianAccountUser {
                email
                extendedProfile {
                  jobTitle
                  department
                }
              }
            }
            state
          }
        }
      }
    }
  }
`;
